export const ExternalNeedVendorFlowSwalActions = {
  REDIRECT: 'redirect',
  RELOAD: 'reload',
};
